<form [formGroup]="getPaginationForm()" class="custom-pagination ng" fxLayout="row" fxLayoutAlign="end center"
      fxLayoutAlign.lt-sm="space-between center" novalidate>
  <div class="form-group" fxLayout="row" >

    <span fxHide.lt-sm>{{'Number of rows' | translate}}:</span>
    <div class="input-container">
      <ng-select
        [items]="getPageSizes()"
        bindLabel="label"
        bindValue="value"
        [searchable]="false"
        [clearable]="false"
        formControlName="itemsPerPage"
      ></ng-select>
    </div>
  </div>
  <div fxHide.lt-sm class="form-group go-to-group" fxLayout fxLayoutAlign.gt-md="end center">
    <span class="go-to-text">{{'Go to' | translate}}:</span>
    <div class="input-container" fxLayout>
      <input
        #currentPageInput
        step="1"
        class="form-control form-control-border"
        max="getMaximumNumberOfPages()" min="1"
        oninput="value=(value < 1) ? 1 : value"
        (input)="checkChange(currentPageInput.value)"
        id="currentPage"
        formControlName="currentPage">
    </div>
  </div>
  <div class="pages-info ellipsis">
    <span *ngIf="totalNumberOfItems !== 0">
      {{(getPaginationForm().controls.currentPage.value === 1) ? 1 : getPaginationForm().controls.currentPage.value * getPaginationForm().controls.itemsPerPage.value + 1 - getPaginationForm().controls.itemsPerPage.value}}
    </span>
    <span *ngIf="totalNumberOfItems === 0">0</span>
    -
    {{(getPaginationForm().controls.currentPage.value * getPaginationForm().controls.itemsPerPage.value > totalNumberOfItems) ?
      totalNumberOfItems : getPaginationForm().controls.currentPage.value * getPaginationForm().controls.itemsPerPage.value}}
    {{'of' | translate}}
    {{totalNumberOfItems}}
  </div>
  <div fxLayout class="nav-buttons-group">
    <div class="nav-button nav-button-left" fxLayoutAlign="center" (click)="goToPage(false)"
         [ngClass]="{'disabled': getPaginationForm().controls.currentPage.value + '' === '1'}">
      <i class="fa fa-caret-left fa-2x" aria-hidden="true"></i>
    </div>
    <div class="nav-button nav-button-right" fxLayoutAlign="center" (click)="goToPage(true)"
         [ngClass]="{'disabled': getPaginationForm().controls.itemsPerPage.value * getPaginationForm().controls.currentPage.value >= totalNumberOfItems}">
      <i class="fa fa-caret-right fa-2x" aria-hidden="true"></i>
    </div>
  </div>

</form>
